module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/96.c94040f8.png";